import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { BaseComponent } from '@app/shared/components/base/base.component';
import { MatLegacyAutocompleteSelectedEvent as MatAutocompleteSelectedEvent } from '@angular/material/legacy-autocomplete';
import { MatLegacyChipInputEvent as MatChipInputEvent } from '@angular/material/legacy-chips';
import { SearchTerm, SearchSuggestionList } from '@app/shared/models/search';

@Component({
    selector: 'search-chips',
    templateUrl: './search-chips.component.html',
    styleUrls: ['./search-chips.component.scss']
})
export class SearchChipsComponent extends BaseComponent implements OnInit {

    @ViewChild('searchInputElement', { static: true })
    public searchInputElement: ElementRef;

    @Input()
    public label?: string;

    @Input()
    public withSuggestions?: boolean;

    @Input()
    public accent?: boolean;

    @Input()
    public searchTerms: SearchTerm[];

    @Input()
    public suggestionList?: SearchSuggestionList;

    @Output()
    public searchTermsChange = new EventEmitter<SearchTerm[]>();

    @Output()
    public searchInputChange = new EventEmitter<string>();

    public searchInput: string;

    protected timerId: number;

    constructor() {
        super();
        this._idPrefix = 'search_chips.';
    }

    public ngOnInit() {
        super.ngOnInit();
        this.label = this.label || 'common.label.search';
        this.searchTerms = this.searchTerms || new Array<SearchTerm>();
    }

    public add(event: MatChipInputEvent): void {
        if (this.searchInput && this.searchInput.trim()) {
            const newManualInput = new SearchTerm({ term: this.searchInput });
            this.addSearchWord(newManualInput, event.input);
        }
    }

    public selected(event: MatAutocompleteSelectedEvent, input: HTMLInputElement): void {
        this.addSearchWord(event.option.value, input);
        this.searchInputChange.emit(this.searchInput);
    }

    protected addSearchWord(searchTerm: SearchTerm, input: HTMLInputElement): void {
        this.cancelTimer();
        this.searchTerms.push(searchTerm);
        this.onSearchTermsChange();
        this.searchInput = '';
        input.value = '';
    }
    
    protected cancelTimer(): void {
        if (this.timerId) {
            clearTimeout(this.timerId);
        }
    }

    public focusSearchInput(): void {
        setTimeout(() => {
            this.searchInputElement.nativeElement.focus();
        });
    }

    public remove(idx: number): void {
        if (idx > -1) {
            this.searchTerms.splice(idx, 1);
            this.onSearchTermsChange();
        }
    }

    public removeAll(): void {
        this.searchTerms = [];
        this.onSearchTermsChange();
    }

    public onSearchTermsChange(): void {
        this.searchTermsChange.emit(this.searchTerms);
    }

    public onKeyup(): void {
        this.cancelTimer();

        this.timerId = setTimeout(() => {
            this.searchInputChange.emit(this.searchInput);
        }, 500);
    }

}
